import React, { useEffect, useState } from 'react';
import { EuiFlexGroup, EuiFlexItem, EuiButton, EuiLoadingContent, EuiText, EuiSpacer } from '@elastic/eui';
import API from '../../api/axios/API';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { getLiveOrders } from '../../api/liveOrders/getLiveOrderNewAPI';
import { getLiveOrderDetailsAPI } from '../../api/liveOrders/getLiveOrderDetailsAPI';

export const ShadowFaxRiderTab = (props) => {
    const { order, onOrderStatusChange } = props;
    const [priceEstimate, setPriceEstimate] = useState({});
    const dispatch = useDispatch();
    const [shadowfaxError, setShadowfaxError] = useState({});

    const tdStyle = {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    };

    const shadowFaxCostEstimate = async () => {
        let shdowFaxResponse;
        try {
            shdowFaxResponse = await API.get(
                `/restaurants/:restaurantId/shadowfax/get-order-estimation-time?orderId=${props.orderId}`
            );
        } catch (error) {
            shdowFaxResponse = error;
        }

        if (shdowFaxResponse.success) {
            setPriceEstimate(shdowFaxResponse);
        } else {
            if (
                shdowFaxResponse?.message === 'NO_FREE_RIDER_AVAILABLE_PLEASE_TRY_AGAIN_IN_SOME_TIME' ||
                shdowFaxResponse?.message?.includes('NO_FREE_RIDER_AVAILABLE_PLEASE_TRY_AGAIN_IN_SOME_TIME') ||
                shdowFaxResponse?.message?.includes('NO_FREE_RIDER_AVAILABLE')
            ) {
                setShadowfaxError({
                    title: 'SURGE ALERT',
                    body: 'Due to excessive orders, there may be a delay in rider assignment and surge fees might be applicable.',
                });
            } else if (shdowFaxResponse?.message?.message) {
                alert(shdowFaxResponse?.message?.message);
            } else {
                setShadowfaxError({});
                alert(shdowFaxResponse.message);
            }
        }
    };

    useEffect(() => {
        shadowFaxCostEstimate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const assignShadowFaxRider = async () => {
        let shadowFaxResponse = '';
        props.setRiderModalOpen();
        try {
            shadowFaxResponse = await API.post(`/restaurants/:restaurantId/shadowfax/assign-order `, {
                orderId: props.orderId,
            });
        } catch (error) {
            shadowFaxResponse = error;
        }

        if (shadowFaxResponse.success) {
            // props.stateUpdateData((prevState) => !prevState)
            dispatch(getLiveOrders());
            dispatch(getLiveOrderDetailsAPI());
            // onOrderStatusChange();
        } else {
            alert(shadowFaxResponse.message);
        }
    };

    return (
        <EuiFlexGroup direction='column'>
            <EuiFlexItem>
                {!isEmpty(priceEstimate) ? (
                    <>
                        {priceEstimate?.shadowfax_order_estimation?.serviceable ? (
                            <EuiFlexItem>
                                <b>ShadowFax Estimates</b>
                                <table style={{ marginTop: '10px' }}>
                                    <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                        <td style={{ borderRight: '1px solid #D3DAE6' }}>Pickup Estimation</td>
                                        <td style={tdStyle}>
                                            {priceEstimate.shadowfax_order_estimation.pickup_eta
                                                ? `${priceEstimate.shadowfax_order_estimation.pickup_eta} Mins`
                                                : ''}
                                        </td>
                                    </tr>
                                    <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                        <td style={{ borderRight: '1px solid #D3DAE6' }}>Drop Estimation</td>
                                        <td style={tdStyle}>
                                            {priceEstimate.shadowfax_order_estimation.drop_eta
                                                ? `${priceEstimate.shadowfax_order_estimation.drop_eta} Mins`
                                                : ''}
                                        </td>
                                    </tr>

                                    <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                        <td style={{ borderRight: '1px solid #D3DAE6' }}>Estimated Delivery Cost</td>

                                        <td style={tdStyle}>
                                            {priceEstimate.shadowfax_order_estimation.delivery_cost
                                                ? `₹${parseFloat(
                                                      priceEstimate.shadowfax_order_estimation.delivery_cost
                                                  ).toFixed(2)}`
                                                : ''}
                                        </td>
                                    </tr>
                                </table>
                            </EuiFlexItem>
                        ) : (
                            <EuiFlexItem>
                                <b>ShadowFax Estimates</b>
                                <table style={{ marginTop: '10px' }}>
                                    <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                        <td style={{ borderRight: '1px solid #D3DAE6' }}>Reason</td>
                                        <td style={tdStyle}>
                                            {priceEstimate.shadowfax_order_estimation.reason
                                                ? priceEstimate.shadowfax_order_estimation.reason
                                                : ''}
                                        </td>
                                    </tr>

                                    <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                        <td style={{ borderRight: '1px solid #D3DAE6' }}>Estimated Delivery Cost</td>

                                        <td style={tdStyle}>
                                            {priceEstimate.shadowfax_order_estimation.delivery_cost
                                                ? `₹${parseFloat(
                                                      priceEstimate.shadowfax_order_estimation.delivery_cost
                                                  ).toFixed(2)}`
                                                : ''}
                                        </td>
                                    </tr>
                                </table>
                            </EuiFlexItem>
                        )}
                    </>
                ) : (
                    <>{isEmpty(shadowfaxError) ? <EuiLoadingContent lines={5} /> : null}</>
                )}
                {!isEmpty(shadowfaxError) ? (
                    <EuiFlexItem style={{ maxWidth: 320 }}>
                        <EuiSpacer size='s' />
                        <EuiText color='warning'>{shadowfaxError.title}</EuiText>
                        <EuiText style={{}} size='s' color='warning'>
                            {shadowfaxError.body}
                        </EuiText>
                    </EuiFlexItem>
                ) : null}
            </EuiFlexItem>
            <EuiFlexItem style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <EuiButton
                    disabled={!priceEstimate?.shadowfax_order_estimation?.serviceable && isEmpty(shadowfaxError)}
                    fullWidth={true}
                    fill
                    onClick={assignShadowFaxRider}
                >
                    Assign Shadow Fax Rider
                </EuiButton>
            </EuiFlexItem>
        </EuiFlexGroup>
    );
};
